var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.statusText)?_c('div',[_vm._v("\n        "+_vm._s(_vm.statusText)+"\n    ")]):_vm._e(),(!_vm.statusText)?_c('div',[_vm._v("\n        "+_vm._s(_vm.hours)+":"+_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }